import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/api/client.js";
import { useMarcelMode } from "@/context/MarcelMode.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

const CARDS = [
  { slot: "friday_dinner", testId: "menu-friday-dinner" },
  { slot: "saturday_breakfast", testId: "menu-saturday-breakfast" },
  { slot: "saturday_lunch", testId: "menu-saturday-lunch" },
  { slot: "saturday_dinner", testId: "menu-saturday-dinner", photo: "/media/patates-dauphinoises.jpg" },
  { slot: "sunday_breakfast", testId: "menu-sunday-breakfast" },
];

export function MenuPage() {
  const { ui } = useOrignalUi();
  const { actingAsAdmin } = useMarcelMode();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [members, setMembers] = useState([]);
  const admin = actingAsAdmin;

  useEffect(() => {
    api("/api/food").then((d) => setItems(d.items || [])).catch(() => {});
    api("/api/members").then((d) => setMembers(d.items || [])).catch(() => {});
  }, []);

  const names = Object.fromEntries(members.map((m) => [m.id, m.display_name || m.first_name]));
  const bySlot = {};
  for (const item of items) (bySlot[item.meal_slot || "info"] ||= []).push(item);

  function assigneeOf(slot) {
    const assigned = (bySlot[slot] || []).find((r) => r.assignee_id);
    return assigned ? names[assigned.assignee_id] || assigned.assignee_id : "";
  }

  return (
    <main className="og-cockpit og-cockpit--menu" data-testid="page-menu">
      <h1>{ui.menu.title}</h1>
      <p className="og-lead" data-testid="menu-lead">{ui.menu.coord}</p>
      <div className="og-meal-cols">
        {CARDS.map((card) => {
          const rows = bySlot[card.slot] || [];
          const who = assigneeOf(card.slot);
          const photo = card.photo || rows.find((r) => r.photo_url)?.photo_url;
          return (
            <section key={card.slot} className="og-panel og-meal-hero" data-testid={card.testId}>
              {photo ? <img src={photo} alt="" className="og-inline-photo" data-testid={card.slot === "saturday_dinner" ? "dauph-photo" : undefined} /> : null}
              <h2>{labelFor(card.slot, ui)}</h2>
              {rows.map((item) => (
                <p key={item.id}><strong>{item.item}</strong></p>
              ))}
              {who ? <p className="og-hint" data-testid={`${card.testId}-who`}>{who}</p> : null}
              {admin ? (
                <button type="button" className="og-btn" onClick={() => navigate(`/taches?new=1&title=${encodeURIComponent(`Préparer — ${labelFor(card.slot, ui)}`)}`)}>
                  {ui.menu.createTask}
                </button>
              ) : null}
            </section>
          );
        })}
      </div>
      <section className="og-panel" data-testid="menu-drinks">
        <h2>{ui.menu.drinks}</h2>
        <p data-testid="drinks-rule">{ui.menu.drinksRule}</p>
      </section>
    </main>
  );
}

function labelFor(slot, ui) {
  return ({
    friday_dinner: ui.menu.fridayEve,
    saturday_breakfast: ui.menu.satBreakfast,
    saturday_lunch: ui.menu.satLunch,
    saturday_dinner: ui.menu.satDinner,
    sunday_breakfast: ui.menu.sunday,
  })[slot] || slot;
}
